import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin, Table } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useInvoices from '../useInvoices';
import { getInvoiceViewSections } from '../invoiceViewSections';
import { invoiceAdapter } from '../edit/invoice.adapter';
import UIHelper from '../../../../../helpers/UIHelper';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const Single = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { id: routeId } = useParams();
  const groupBy = searchParams.get('group_by') || 'week';
  const { singleItem, loading, statusTexts } = useInvoices(false);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  const sections = useMemo(
    () =>
      getInvoiceViewSections(t, viewItem, { groupBy, statusTexts }),
    [t, viewItem, groupBy, statusTexts],
  );

  const dailyRows = useMemo(() => {
    const rows = viewItem?.allData?.invoices;
    if (!rows?.length) {
      return [];
    }
    return invoiceAdapter(rows);
  }, [viewItem]);

  const dailyColumns = useMemo(
    () => [
      {
        title: t('Date'),
        dataIndex: 'invoice_date',
        width: 160,
        render: (row) => UIHelper.formatedDate(row, 'dddd, DD MMMM YYYY'),
      },
      { title: t('Netto (€)'), dataIndex: 'taxable', width: 100 },
      { title: t('Lordo (€) %'), dataIndex: 'taxable_vat', width: 100 },
      { title: t('SCONTRINI'), dataIndex: 'receipts', width: 100 },
      { title: t('PEZZI'), dataIndex: 'pieces', width: 100 },
      { title: t('VISITATORI'), dataIndex: 'visitors', width: 100 },
      { title: t('ATV'), dataIndex: 'atv', width: 80 },
      { title: t('UPT'), dataIndex: 'upt', width: 80 },
      { title: t('Conversion Rate'), dataIndex: 'conversion_rate', width: 120 },
      {
        title: t('GIORNO DI CHIUSURA'),
        dataIndex: 'day_off',
        width: 120,
        render: (value) => (value ? t('Yes') : t('No')),
      },
    ],
    [t],
  );

  const pageTitle =
    viewItem?.company_name || t('Fatturato settimanale');

  const showEdit =
    (viewItem?.can_update !== false || viewItem?.can_approve) &&
    groupBy === 'week';

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
          {dailyRows.length > 0 && (
            <div style={{ marginTop: 24 }}>
              <h3>{t('Dettaglio giornaliero')}</h3>
              <Table
                columns={dailyColumns}
                dataSource={dailyRows}
                pagination={false}
                size='small'
                rowKey='id'
                scroll={{ x: 1000 }}
              />
            </div>
          )}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {showEdit && (
            <Col>
              <Button>
                <Link to={`/finance/invoices/${routeId}/edit`}>
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/finance/invoices'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Single;
